import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: []
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' }
      ]
    },
    Theme: {
      validations: []
    },
    Reference: {
      validations: []
    },
    Notes: {
      validations: []
    },
    Website: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'FirstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'Email'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
          },
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State',
            options: [
              { label: 'New South Wales', value: 'New South Wales' },
              { label: 'Queensland', value: 'Queensland' },
              { label: 'Australian Capital Territory', value: 'Australian Capital Territory' },
              { label: 'Victoria', value: 'Victoria' },
              { label: 'South Australia', value: 'South Australia' },
              { label: 'Western Australia', value: 'Western Australia' },
              { label: 'Northern Territory', value: 'Northern Territory' },
              { label: 'Tasmania', value: 'Tasmania' }             
            ],
            mapping: 'State'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Postcode:',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Please select one of the below options regarding your inquiry.',
            options: [
              { label: 'Activities' , value: 'Activities'},
              { label: 'Conference', value: 'Conference'},
              { label: 'Christmas Party', value: 'Christmas Party'},
              { label: 'Corporate Group', value: 'Corporate Group' },
              { label: 'Leisure Group', value: 'Leisure Group' },
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Agistment', value: 'Agistment' },
              { label: 'Media', value: 'Media' },
              { label: 'Other', value: 'Other' }
            ],
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Please tell us, how did you hear about Glenworth Valley?',
            options: [
              { label: 'Visited previously' , value: 'Visited previously'},
              { label: 'Word of mouth/Friend', value: 'Word of mouth/Friend'},
              { label: 'Radio Advertising', value: 'Radio Advertising'},
              { label: 'Newspaper', value: 'Newspaper' },
              { label: 'Google', value: 'Google' },
              { label: 'Google advertising (AdWords)', value: 'Google advertising (AdWords)' },
              { label: 'Referring Website', value: 'Referring Website' },
              { label: 'Facebook', value: 'Facebook' },
              { label: 'Instagram', value: 'Instagram' },
              { label: 'Email', value: 'Email' },
              { label: 'Wedding Expo', value: 'Wedding Expo' },
            ],
            mapping: 'Reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Comments or Queries',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Glenworth Valley Outdoor Adventures Weddings Form',
    formId: '445',
    clientKey: 'B8B25360-8C0A-46C0-B58A-F740D70CB9DA',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/web_inquiry/inquiry-renderer/client_forms/glenworthvalley1/form_structure.js